module.exports = __webpack_public_path__ + "img/frontendsource_jekyll.da2123d0.svg";